module.exports = __webpack_public_path__ + "img/avatar5.e638d6b8.png";